import { useState, type PropsWithChildren } from "react";
import {
  PrimaryNavigationStripFloatingTabsContext,
  createPrimaryNavigationStripFloatingTabsRegistry,
} from "#primary-navigation-strip-floating-tabs-context";

/**
 * Wraps the app shell, above both the scenes that float tabs and the overlays that avoid them (the
 * Admin panel's bottom placement), which live outside the tab navigator.
 */
export function PrimaryNavigationStripFloatingTabsProvider({ children }: PropsWithChildren) {
  const [registry] = useState(() => createPrimaryNavigationStripFloatingTabsRegistry());
  return (
    <PrimaryNavigationStripFloatingTabsContext value={registry}>
      {children}
    </PrimaryNavigationStripFloatingTabsContext>
  );
}
